import React, { FunctionComponent, useContext } from "react";
import { RegisterButton } from "../hero/new";
import Context from "../../context/Context";
import { useEventContext } from "../../context/EventProvider";
import { Facebook, LinkedIn, YouTube, X } from "@mui/icons-material";

const Footer: FunctionComponent = (props: any) => {
  const data = useContext(Context);
  const { socialShare } = data;
  const { event: { url, email, emailSubject } } = useEventContext();
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-logo-and-cta">
          <div className="footer-main-image">
            <img src="https://cdn.ems.prod.upgather.com/uploads/Google_PS_Logo_8e61f577a2.svg" alt="Google" />
          </div>
          <div className="footer-main-text">Public Sector Summit</div>
          
          {/*<img src="https://cdn.ems.prod.upgather.com//uploads/AI_Talks_Main_Hero_Logo_511462d92b.svg" alt="Logo" />*/}
          
          <RegisterButton />
          <div className="social-nav-container">
          <span className="socialFollowtxt">Follow us</span><br className="footer-mobile-break" />
            <a
                className="social-icon youtube"
                href="https://www.youtube.com/googlecloud"
                target={"_blank"}
                
              >
                <YouTube />
            </a>
            <a
                className="social-icon linkedin"
                href="https://www.linkedin.com/showcase/google-cloud/"
                target={"_blank"}
                
              >
                <LinkedIn />
            </a>
            <a
                className="social-icon twitter"
                href="https://x.com/googlecloud"
                target={"_blank"}
                
              >
                <X />
            </a>
            <a
                className="social-icon facebook"
                href="https://www.facebook.com/googlecloud/"
                target={"_blank"}
                
              >
                <Facebook />
            </a>
        </div>
        <div className="hashtag"><span>#GooglePSSummit</span></div>
          {/*<div className="footer-social-icons">
          
          <div><a href="https://www.facebook.com/sharer/sharer.php?u=https://aitalks.upgather.com" target="_blank">FACEBOOK</a></div>
          <div><a href="https://www.linkedin.com/sharing/share-offsite/?url=https://aitalks.upgather.com" target="_blank">LINKEDIN</a></div>
          <div><a href="http://www.twitter.com/share?url=https://aitalks.upgather.com" target="_blank">X</a></div>
        </div>*/}
        </div>
        
      </div>
    </footer>
  );
};

export default Footer;
